import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('lt');

  const toggleLanguage = () => {
    setLanguage((current) => (current === 'lt' ? 'en' : 'lt'));
  };

  useEffect(() => {
    const copy = {
      lt: {
        title: 'Filmviewing | Filmų peržiūros gidas',
        description: 'Filmviewing sudėlioja filmus į nuotaikos takelius ir trumpas peržiūros pastabas.',
      },
      en: {
        title: 'Filmviewing | A film viewing guide',
        description: 'Filmviewing arranges films into mood lanes and short viewing notes.',
      },
    };
    const t = copy[language];
    document.documentElement.lang = language === 'lt' ? 'lt' : 'en';
    document.title = t.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', t.description);
  }, [language]);

  return (
    <div className="min-h-screen bg-ink text-paper font-body">
      <Header language={language} onToggleLanguage={toggleLanguage} />
      <main>
        <Hero language={language} />
        <Features language={language} />
        <HowItWorks language={language} />
        <Benefits language={language} />
        <CTA language={language} />
      </main>
      <Footer language={language} />
    </div>
  );
}

export default App;
